(function () {
  var modalEl;
  var needLogin = true;
  function isLoggedIn() {
    try {
      return typeof customerId !== "undefined" && customerId !== null && customerId !== "";
    } catch (e) {
      return false;
    }
  }
  function open() {
    if (!modalEl) return;
    modalEl.hidden = false;
    modalEl.classList.add("is-active");
    modalEl.setAttribute("aria-hidden", "false");
    window._erj_?.lockScroll?.();
    if (typeof gtag === "function") {
      gtag("event", "wishlist-login-open");
    }
  }
  function close() {
    if (!modalEl) return;
    modalEl.classList.remove("is-active");
    modalEl.hidden = true;
    modalEl.setAttribute("aria-hidden", "true");
    window._erj_?.unlockScroll?.();
    if (typeof gtag === "function") {
      gtag("event", "wishlist-login-close");
    }
  }
  function onDocClickCapture(e) {
    var t = e.target;
    var trigger = t && t.closest && t.closest("[data-requires-login]");
    if (!trigger) return;
    if (isLoggedIn()) return;
    e.preventDefault();
    e.stopPropagation();
    open();
  }
  function bind() {
    modalEl = document.getElementById("login-modal");
    if (!modalEl) return;
    needLogin = Boolean(window._erj_?.settings?.need_wishlist_login);
    var closes = modalEl.querySelectorAll("[data-login-modal-close]");
    closes.forEach(function (el) {
      el.addEventListener("click", close, false);
    });

    modalEl.addEventListener("click", function (e) {
      var t = e.target;
      if (!t || !t.closest) return;

      var trackTrigger = t.closest("[data-tracking-event]");
      if (trackTrigger) {
        var eventName = trackTrigger.getAttribute("data-tracking-event");
        if (eventName && typeof gtag === "function") {
          if (eventName === "login_from_wishlist") {
            gtag("event", eventName, { login_method: "account" });
          } else {
            gtag("event", eventName);
          }
        }
      } else if (t.closest(".h_google_button")) {
        if (typeof gtag === "function") {
          gtag("event", "login_from_wishlist", { login_method: "google" });
        }
      } else if (t.closest(".h_facebook_button")) {
        if (typeof gtag === "function") {
          gtag("event", "login_from_wishlist", { login_method: "facebook" });
        }
      }
    });

    document.addEventListener("click", onDocClickCapture, true);
    window.addEventListener("enroute:open-login-modal", function () {
      if (!isLoggedIn() && needLogin) open();
    });
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bind);
  } else {
    bind();
  }
  window.EnrouteLoginModal = window.EnrouteLoginModal || { open: open, close: close };
})();
